/*
 * @Description  :
 * @Author       : lcs
 * @Date         : 2023-12-22 00:44:11
 * @LastEditors  : luchaoshun@ihaier.com
 * @LastEditTime : 2023-12-28 21:15:09
 */
/** 全局配置表 */
// 协议
const protocol = window.protocal
  ? window.protocal
  : process.env.NODE_ENV === 'production'
  ? 'http'
  : 'http'
// mock环境
const mock_baseUrl = `${protocol}://101.200.54.239:7777/mock/5d09de693b9c0c22d4b7bc10/cfb`
// 开发(联调)环境
// const dev_baseUrl = `${protocol}://api.cfb.dev.test.datounet.com`
// const dev_baseUrlC = `${protocol}://cfb.dev.test.datounet.com`

const dev_baseUrl = `http://localhost:8080`
const dev_baseUrlC = `${protocol}://www.cfbchina.org.cn`
// const dev_baseUrl = `${protocol}://api.cfbchina.org.cn`;
// 测试环境
const test_baseUrl = `${protocol}://api.cfb.qa.test.datounet.com`
const test_baseUrlC = `${protocol}://cfb.qa.test.datounet.com`
// 生产环境
// const pro_baseUrl = `${protocol}://testapi.datounet.com`;
const pro_baseUrl = `${protocol}://api.cfbchina.org.cn`
const pro_baseUrlC = `${protocol}://www.cfbchina.org.cn`
// const pro_baseUrlC = `${protocol}://testcfb.datounet.com`;

// api请求地址
export const baseUrl = getBaseUrl()
export const baseUrlC = getBaseUrlC()

// 高德地图api凭据
export const amapKey = '223462ea0c0e146bf4a405031a9fd2d7'

// 静态图片域名 - OSS
export const oss_baseUrl = `${protocol}://cfb-bucket.oss-cn-beijing.aliyuncs.com`

// 错误码常量
export const errCode = {
  5001001: '未获取到token',
  5001002: '无效的token',
  5001003: '注册失败',
  5001004: '用户异常'
}

// 请求地址处理
function getBaseUrl() {
  let currentUrl = ''
  switch (process.env.NODE_ENV) {
    case 'mock':
      currentUrl = mock_baseUrl
      break
    case 'development':
      currentUrl = '/api' + dev_baseUrl // 设置代理
      break
    case 'test':
      currentUrl = test_baseUrl
      break
    case 'production':
      currentUrl = pro_baseUrl
      break
  }
  // 全局域名覆盖(有值就覆盖 一般不使用)
  if (window.domain) {
    currentUrl = `${protocol}://${window.domain}`
  }
  console.log(`
        当前环境：${process.env.NODE_ENV}, baseUrl:${currentUrl}
        window.protocol:${window.protocol}, window.domain:${window.domain}
    `)
  return currentUrl
}
// 请求地址处理
function getBaseUrlC() {
  let curl = ''
  switch (process.env.NODE_ENV) {
    case 'mock':
      curl = mock_baseUrl
      break
    case 'development':
      curl = dev_baseUrlC
      break
    case 'test':
      curl = test_baseUrlC
      break
    case 'production':
      curl = pro_baseUrlC
      break
  }
  // 全局域名覆盖(有值就覆盖 一般不使用)
  if (window.domain_curl) {
    curl = `${protocol}://${window.domain_curl}`
  }
  console.log(`
        当前环境：${process.env.NODE_ENV}, baseUrl:${curl}
        window.protocol:${window.protocol}, window.domain:${window.domain_curl}
    `)
  return curl
}
